import { Form } from "formik";
import { useSelector } from "react-redux";
import Select, { MultiValue } from "react-select";
import useFetch from "../../hooks/useFetch";
import { api } from "../../config/Api";
import { FormInterface, IndustryForSelect, PositionInterface, StateInterface } from "../../helper/interface";

const AddOrEditPosition = ({
    errors,
    touched,
    handleChange,
    values,
    handleBlur,
    dirty,
    setFieldValue,
    setFieldTouched,
    isEdit = false,
}: FormInterface<PositionInterface> & { isEdit?: boolean }) => {
    const loading = useSelector((state: StateInterface) => state.base.loading);

    const industries = useFetch<IndustryForSelect[]>(api.admin.getAllIndustryForSelect);

    return (
        <Form>
            <div className="grid grid-cols-12 gap-4 gap-y-5 mt-5">
                <div className="intro-y col-span-12 sm:col-span-6">
                    <label htmlFor="name" className="form-label">
                        Position
                    </label>
                    <input
                        id="name"
                        name="name"
                        type="text"
                        autoFocus
                        onChange={handleChange}
                        value={values.name}
                        onBlur={handleBlur}
                        className={`form-control ${errors.name && touched.name && "border-danger"}`}
                        placeholder="Qualified"
                    />
                    {errors.name && touched.name && <div className="text-danger">{errors.name}</div>}
                </div>
                <div className="intro-y col-span-12 sm:col-span-6">
                    <label className="mb-2 form-label">Industries</label>
                    <div className="">
                        {industries?.res?.data ? (
                            <Select
                                isMulti
                                name="industries"
                                options={industries?.res?.data}
                                value={values?.industries}
                                onBlur={() => setFieldTouched("industries", true)}
                                onChange={(selectedItem: MultiValue<IndustryForSelect>) => {
                                    setFieldValue("industries", selectedItem);
                                }}
                                className={`form-control tom-select ${errors.industries && touched.industries && "border-danger"}`}
                                classNamePrefix="select"
                                getOptionLabel={(option) => option.name}
                                getOptionValue={(option) => String(option.industryId)}
                            />
                        ) : null}
                    </div>
                    {errors.industries && touched.industries && <div className="text-danger">{errors.industries}</div>}
                </div>
                {!isEdit ? (
                    <div className="intro-y col-span-12 sm:col-span-6">
                        <label className="mb-2 form-label">Add this position to all schedulers</label>
                        <div className="form-switch form-check" style={{ height: "37px" }}>
                            <input
                                id="addPositionPermissionToAllSchedulers"
                                name="addPositionPermissionToAllSchedulers"
                                onChange={() =>
                                    setFieldValue(
                                        "addPositionPermissionToAllSchedulers",
                                        !values.addPositionPermissionToAllSchedulers
                                    )
                                }
                                checked={Boolean(values.addPositionPermissionToAllSchedulers)}
                                className={"form-check-input"}
                                type="checkbox"
                            />
                        </div>
                    </div>
                ) : null}
                <div className="intro-y col-span-12 flex items-center justify-center sm:justify-end mt-5">
                    <button className="btn btn-secondary w-24" type="reset" disabled={!dirty}>
                        Reset
                    </button>
                    <button className="btn btn-primary w-24 ml-2" type="submit" disabled={loading || !dirty}>
                        Save
                    </button>
                </div>
            </div>
        </Form>
    );
};

export default AddOrEditPosition;
